export default __webpack_public_path__ + "media/zurb/fonts/ProximaNova-Light-683a9222ad99505c07013e6be5c29399.woff2";